import './App.css';
import Side from './Side';
import 'react-router-dom';
import {BrowserRouter as Router, Routes,Route} from "react-router-dom";
import Overview from './Overview';
import Messages from './Messages';
import Video from './Video';
import Doc from './Doc';
import Settings from './Settings';

function App() {
  return (
    <div className="App">
  
    <Router>
        <Side to="/" />
        <Routes>
            <Route path="/" element={<Overview />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/video" element={<Video />} />
            <Route path="/doc" element={<Doc />} />
            <Route path="/settings" element={<Settings />} />
        </Routes>
    </Router>



    </div>
  );
}

export default App;
